export default __webpack_public_path__ + "static/media/pencil.b0679974.svg";